module.exports = __webpack_public_path__ + "4e61b6df86407742882b34ad3fa72cb3.png";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/Ueberseeinsel_trans_4c.png
// module id = 959
// module chunks = 0